export const OFFLINE_SHELL_EVENT = "retailpulse:offline-shell";
let registration: ServiceWorkerRegistration | undefined;
export function offlineRegistration() { return registration; }

export async function registerOfflineShell(): Promise<void> {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  const base = import.meta.env.BASE_URL;
  registration = await navigator.serviceWorker.register(`${base}offline-sw.js`, { scope: base, updateViaCache: "none" });
  const notify = () => window.dispatchEvent(new Event(OFFLINE_SHELL_EVENT));
  navigator.serviceWorker.addEventListener("controllerchange", notify);
  registration.addEventListener("updatefound", () => {
    registration?.installing?.addEventListener("statechange", notify);
  });
  await navigator.serviceWorker.ready;
  notify();
}
